import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from "moment";
import _ from "underscore";

import TypeaheadResult from "pattern-library/dist/js/components/TypeaheadResult";
import Typeahead from "pattern-library/dist/js/components/Typeahead";
import * as marketingActions from "../../actions/marketingPage";

class SearchTraining extends Component {
    constructor() {
        super();

        this.state = {
            searchText: ''
        };
    }

    componentDidMount() {
        this.getSearchResults = _.debounce(this.props.getSearchResults, 300);
    }

    _handleSearch(searchTerm){
        this.setState({
            searchText: searchTerm
        });
        this.getSearchResults(searchTerm);
    }

    render() {
        const Results = this.props.searchResults;

        return (
            <Typeahead
                label={this.props.label}
                placeholder={this.props.placeholder}
                value={this.state.searchText}
                onChange={t => this._handleSearch(t)}
                className="rhe-typeahead-example"
                onSelectResult={result => {
                    this.props.onSelectResult(result);
                    this.setState({
                        searchText: ""
                    })
                }}
                disabled={this.props.disabled}
            >
                {Results && Results.map(r => {
                    let type;
                    if('name' in r){
                        if(r.elearning_course_id !== null){
                            type = "E-Learning Course: ";
                        }else{
                            type = "Course: ";
                        }
                    }else{
                        type = "Event: ";
                    }

                    const date = 'start_date' in r ? moment(r.start_date).format('Do MMMM Y') : null;
                    const location = 'venue' in r ? r.venue.address.address_1 + " " + r.venue.address.post_code : null;

                    return (
                        <TypeaheadResult
                            key={r.id}
                            value={r}
                        >
                            {type} {'name' in r ? r.name : r.course_name} {date} {location !== null ? 'at' : null} {location}
                        </TypeaheadResult>
                    )
                })}
            </Typeahead>
        )
    }
}

const mapStateToProps = state => {
    return {
        searchResults: state.marketingPage.searchResults,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getSearchResults(searchTerm){
            dispatch(marketingActions.getSearchResults(searchTerm));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchTraining);


// WEBPACK FOOTER //
// ./components/SearchTraining/index.js